"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3883],{

/***/ 4847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useImageDataHandler; }
/* harmony export */ });
/* unused harmony export imageDataHandler */
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _contexts_ViewportContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9366);
/* harmony import */ var _util_magnolia__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7581);
/* harmony import */ var _util_viewport__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5625);





/**
 * Hook to generate an image handler function.
 *
 * Options can be passed to handler function to optimise image size.
 * If the image does not to bigger than "sm" in any viewport, then
 * `maxViewport` option should be set to `Viewport.sm`.
 *
 * Image sizes (width) for each viewport size:
 * - xs: 600px
 * - sm: 800px
 * - md: 900px
 * - lg: 1024px
 * - xl: 1440px
 */ function useImageDataHandler() {
    var isPreview = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().isPreview;
    var viewport = (0,_contexts_ViewportContext__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().viewport;
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(image, options) {
        return imageDataHandler(image, viewport, isPreview, options);
    }, [
        isPreview,
        viewport
    ]);
}
/**
 * Get image information from MGNL (MGNL = Magnolia)
 * @param image - Image object from MGNL
 * @param viewport - Viewport from store
 * @returns Object containing "imageSrc" (image url), "imageLoader" (loader to handle next/image)
 *  and boolean "fallback", to show a fallback image if current image is not published in MGNL
 */ function imageDataHandler(image, viewport) {
    var isPreview = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, options = arguments.length > 3 ? arguments[3] : void 0;
    if (typeof image === "string" || !image) return {
        src: "",
        width: 0,
        height: 0,
        imageLoader: undefined,
        imageSrc: ""
    };
    var _metadata = image.metadata, width = _metadata.width, height = _metadata.height;
    var src = (0,_util_magnolia__WEBPACK_IMPORTED_MODULE_3__/* .formatAssetLink */ .Qz)(image["@link"], isPreview).toString();
    var optimisedViewport = (0,_util_viewport__WEBPACK_IMPORTED_MODULE_4__/* .optimiseViewport */ .s)(viewport, options);
    var imageLoader = function() {
        var ref;
        return optimisedViewport && ((ref = image.renditions) === null || ref === void 0 ? void 0 : ref[optimisedViewport].link) ? (0,_util_magnolia__WEBPACK_IMPORTED_MODULE_3__/* .formatAssetLink */ .Qz)(image.renditions[optimisedViewport].link, isPreview) : src;
    };
    return {
        src: src,
        width: width,
        height: height,
        imageLoader: imageLoader,
        imageSrc: src
    };
}


/***/ }),

/***/ 3883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ArticlePageHero; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useKeyDown-88662051.mjs
var useKeyDown_88662051 = __webpack_require__(403);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image-be3826ec.mjs
var Image_be3826ec = __webpack_require__(567);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Video-83c15c06.mjs
var Video_83c15c06 = __webpack_require__(2645);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Icon-e01b6482.mjs
var Icon_e01b6482 = __webpack_require__(2007);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Button-eec2778c.mjs
var Button_eec2778c = __webpack_require__(9358);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useClickOutside-55c64a80.mjs
var useClickOutside_55c64a80 = __webpack_require__(7720);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/ArticlePageHero.js









const y = "hero-ratio", P = "article__hero-container", I = "desktop", w = "hero-ratio-without-quote", A = "article__hero-container--without-quote", D = "article__header", F = "article__header__no-buttons", G = "article__save-button", M = "article__save-button__svg", O = "button__icon", V = "article__hero-container__wrapper", j = "article__hero-container__wrapper__reference", z = "article__hero-container__wrapper__reference__text", J = "article__hero-container__no-sibling", K = "article__quote", U = "article__quote__light", X = "article__quote__text__dark__title", Y = "article__quote__text__light__title", Z = "article__quote__text__light__source", $ = "article__quote__text__light__ranking", ee = "article__leadText", te = "article__description", t = {
  heroRatio: y,
  articleHeroContainer: P,
  desktop: I,
  heroRatioWithoutQuote: w,
  articleHeroContainerWithoutQuote: A,
  articleHeader: D,
  articleHeaderNoButtons: F,
  articleSaveButton: G,
  articleSaveButtonSvg: M,
  buttonIcon: O,
  articleHeroContainerWrapper: V,
  articleHeroContainerWrapperReference: j,
  articleHeroContainerWrapperReferenceText: z,
  articleHeroContainerNoSibling: J,
  articleQuote: K,
  articleQuoteLight: U,
  articleQuoteTextDarkTitle: X,
  articleQuoteTextLightTitle: Y,
  articleQuoteTextLightSource: Z,
  articleQuoteTextLightRanking: $,
  articleLeadText: ee,
  articleDescription: te
};
function f(l) {
  const {
    quote: { field: s, title: c, source: _, ranking: h }
  } = l, a = s === "light", o = (0,useKeyDown_88662051.c)(
    t.articleQuote,
    a && t.articleQuoteLight
  ), p = (0,useKeyDown_88662051.c)({
    [useKeyDown_88662051.t.textsLeadTextBold]: a,
    [t.articleQuoteTextLightTitle]: a,
    // Override light mode styling and typography with dark mode
    [useKeyDown_88662051.t.textsLeadText]: !a,
    [t.articleQuoteTextDarkTitle]: !a
  });
  let d = "", m = "";
  return a && (d = (0,useKeyDown_88662051.c)(
    useKeyDown_88662051.t.textsLeadText,
    t.articleQuoteTextLightSource
  ), m = (0,useKeyDown_88662051.c)(
    useKeyDown_88662051.t.textsLeadTextBold,
    t.articleQuoteTextLightRanking
  )), /* @__PURE__ */ react.createElement(
    "div",
    {
      className: o,
      "data-testid": "article-page-hero-quote-container"
    },
    a ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("p", { className: m }, "#", h), /* @__PURE__ */ react.createElement("p", { className: p, itemProp: "description" }, c), /* @__PURE__ */ react.createElement("p", { className: d }, _)) : /* @__PURE__ */ react.createElement("p", { className: p, itemProp: "description" }, c)
  );
}
function ae({ isSaved: l = !1, onClick: s }) {
  const c = l ? Icon_e01b6482.W.HEART_FILLED : Icon_e01b6482.W.HEART;
  return /* @__PURE__ */ react.createElement(
    Button_eec2778c.B.IconLabel,
    {
      text: "Save",
      onClick: s,
      icon: {
        type: c,
        size: 16,
        className: t.articleSaveButtonSvg
      }
    }
  );
}
function _e(l) {
  const {
    assetType: s,
    heading: c,
    leadText: _,
    heroSource: h,
    imageReference: a,
    quote: o,
    isSaved: p,
    onSave: d,
    hasIcons: m,
    description: x
  } = l, { displaySource: n, altText: C, mimeType: L, credits: N } = h, T = (0,react.useRef)(null), H = (0,useKeyDown_88662051.c)(
    useKeyDown_88662051.t.headingPage,
    t.articleHeader,
    m ? "" : t.articleHeaderNoButtons
  ), S = (0,useKeyDown_88662051.c)(t.articleHeroContainer, {
    [t.articleHeroContainerWithoutQuote]: !o,
    [t.articleHeroContainerNoSibling]: !(T.current && T.current.nextElementSibling)
  }), v = (0,useKeyDown_88662051.c)(
    useKeyDown_88662051.t.textsCaption,
    t.articleHeroContainerWrapperReferenceText
  ), Q = (0,useKeyDown_88662051.c)(
    useKeyDown_88662051.t.textsComponentTitleBold,
    t.articleLeadText
  ), R = (0,useKeyDown_88662051.c)(
    useKeyDown_88662051.t.textsLeadText,
    t.articleDescription
  ), u = typeof n != "string";
  return /* @__PURE__ */ react.createElement("div", { className: "article", "data-testid": "article-page" }, /* @__PURE__ */ react.createElement(
    useClickOutside_55c64a80.B,
    {
      topPadding: useClickOutside_55c64a80.B.Padding.SMALL,
      bottomPadding: useClickOutside_55c64a80.B.Padding.LARGE,
      "data-testid": "article-page-block"
    },
    /* @__PURE__ */ react.createElement(
      useClickOutside_55c64a80.B.Content,
      {
        "data-testid": "article-page-block-content",
        itemScope: !0,
        itemType: "https://schema.org/Thing"
      },
      /* @__PURE__ */ react.createElement("h1", { className: H, itemProp: "name" }, c),
      m && /* @__PURE__ */ react.createElement(
        "div",
        {
          className: t.articleSaveButton,
          "data-testid": "article-page-save-button"
        },
        /* @__PURE__ */ react.createElement(ae, { onClick: d, isSaved: p })
      ),
      /* @__PURE__ */ react.createElement(
        "div",
        {
          className: S,
          ref: T,
          itemScope: !0,
          itemType: "https://schema.org/ImageObject"
        },
        s === "image" ? /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("div", { className: t.articleHeroContainerWrapper }, /* @__PURE__ */ react.createElement(
          Image_be3826ec.I,
          {
            src: u ? n.imageSrc : "",
            width: u ? n.width : 0,
            height: u ? n.height : 0,
            altText: C,
            imageLoader: u ? n.imageLoader : () => "",
            styling: Image_be3826ec.a.ARTICLE_PAGE_HERO,
            "data-testid": "article-page-image",
            credits: N
          }
        ), a && /* @__PURE__ */ react.createElement(
          "div",
          {
            className: t.articleHeroContainerWrapperReference,
            "data-testid": "article-hero-image-reference"
          },
          /* @__PURE__ */ react.createElement(
            "p",
            {
              className: v,
              itemProp: "citation"
            },
            a
          )
        )), o && /* @__PURE__ */ react.createElement(f, { quote: o })) : /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(
          Video_83c15c06.V,
          {
            title: C,
            autoplay: !0,
            videoType: "asset",
            video: {
              src: u ? "" : n,
              mimeType: L
            },
            "data-testid": "article-page-video"
          }
        ), o && /* @__PURE__ */ react.createElement(f, { quote: o }))
      ),
      _ && /* @__PURE__ */ react.createElement("p", { className: Q, itemProp: "description" }, _),
      x && /* @__PURE__ */ react.createElement(
        "div",
        {
          className: (0,useKeyDown_88662051.c)(useKeyDown_88662051.t.richText, R),
          itemProp: "description"
        },
        x
      )
    )
  ));
}

//# sourceMappingURL=ArticlePageHero.js.map

// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/constants/app.ts
var app = __webpack_require__(5884);
// EXTERNAL MODULE: ./src/contexts/PageContentContext.tsx
var PageContentContext = __webpack_require__(6548);
// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
// EXTERNAL MODULE: ./src/contexts/SaveItemsToStorageContext.tsx
var SaveItemsToStorageContext = __webpack_require__(2433);
;// CONCATENATED MODULE: ./src/magnolia/components/ArticlePageHero/ArticlePageHero.tsx











var HtmlParser = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1682).then(__webpack_require__.bind(__webpack_require__, 1682));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1682)
            ];
        }
    }
});
function ArticlePageHero(props) {
    var heading = props.heading, leadText = props.leadText, asset = props.asset, imageReference = props.imageReference, quote = props.quote, icons = props.icons, description = props.description;
    var isPreview = (0,router.useRouter)().isPreview;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    var ref = (0,SaveItemsToStorageContext/* default */.Z)(), toggleItemInLocalStorage = ref.toggleItemInLocalStorage, isSaved = ref.isSaved;
    var currentPage = (0,PageContentContext/* default */.Z)();
    var generateHeroSource = function() {
        var ref;
        if (asset.field === "image") {
            var image = asset.image;
            var credits = "";
            if (typeof image !== "string") {
                var ref1;
                var ref2;
                credits = (ref2 = image === null || image === void 0 ? void 0 : (ref1 = image.metadata) === null || ref1 === void 0 ? void 0 : ref1.rights) !== null && ref2 !== void 0 ? ref2 : "";
            }
            var imageData = imageDataHandler(image, {
                maxViewport: app/* Viewport.md */.l_.md
            });
            return {
                displaySource: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
                    imageSrc: imageData.src
                }),
                altText: asset.imageAltText || "",
                mimeType: undefined,
                credits: credits
            };
        }
        return {
            displaySource: (0,magnolia/* getAssetPath */.K3)(asset.video, isPreview),
            imageLoadHandler: undefined,
            altText: asset.videoAltText || "",
            mimeType: (ref = asset.video.metadata) === null || ref === void 0 ? void 0 : ref.mimeType
        };
    };
    var handleSaveItem = function() {
        var id = currentPage["@id"];
        var path = currentPage["@path"];
        var cleanedDescription = description === null || description === void 0 ? void 0 : description.replace(/[<p></p>]/g, "");
        var introImage = currentPage.introductionImage;
        if (!introImage) return null;
        var newSaveItemObj = {
            id: id,
            title: heading,
            description: cleanedDescription,
            pageLink: path,
            image: introImage,
            type: "masonryCard"
        };
        toggleItemInLocalStorage(newSaveItemObj);
    };
    var descriptionOrUndefined = (description === null || description === void 0 ? void 0 : description.trim()) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlParser, {
        html: description
    }) : undefined;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_e, {
        assetType: asset.field,
        heading: heading,
        leadText: leadText === null || leadText === void 0 ? void 0 : leadText.trim(),
        heroSource: generateHeroSource(),
        imageReference: imageReference,
        quote: getQuoteFromQuoteNode(quote),
        hasIcons: icons === "true",
        description: descriptionOrUndefined,
        isSaved: isSaved(currentPage === null || currentPage === void 0 ? void 0 : currentPage["@id"]),
        onSave: handleSaveItem
    });
}
function getQuoteFromQuoteNode(node) {
    if (node.field === "none") return undefined;
    return {
        field: node.field,
        title: node.title,
        source: node.source,
        ranking: node.ranking
    };
}

;// CONCATENATED MODULE: ./src/magnolia/components/ArticlePageHero/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 2645:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ h; },
/* harmony export */   "a": function() { return /* binding */ C; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(403);
/* harmony import */ var _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7720);



const A = "video", f = "video__hero", g = "video__article", k = "desktop", P = "video__caption", d = {
  video: A,
  videoHero: f,
  videoArticle: g,
  desktop: k,
  videoCaption: P
};
var C = /* @__PURE__ */ ((t) => (t.ARTICLE = "videoArticle", t.HERO = "videoHero", t))(C || {});
function h({
  title: t,
  caption: s,
  styling: i,
  autoplay: l,
  embed: o,
  image: u = "",
  videoType: c,
  video: r,
  viewport: m
}) {
  const E = Array.isArray(r) ? r.find((y) => m && y.device?.includes(m)) : r, a = (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(d.video, i && d[i]), p = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, c === "icareusIframe" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: a,
      dangerouslySetInnerHTML: { __html: o }
    }
  ), c === "embed" && (o?.includes("iframe") ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: a,
      dangerouslySetInnerHTML: { __html: o }
    }
  ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      "data-testid": "videoplayer-embed",
      itemProp: "video",
      title: t,
      className: a,
      src: o,
      playsInline: !0,
      controls: !0
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("track", { kind: "captions" })
  )), c === "asset" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, l ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      "data-testid": "videoplayer-asset",
      itemProp: "video",
      title: t,
      className: a,
      src: E?.src,
      autoPlay: l,
      loop: !0,
      muted: !0,
      playsInline: !0
    }
  ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      "data-testid": "videoplayer-asset-control",
      itemProp: "video",
      title: t,
      className: a,
      controls: !0,
      poster: u,
      playsInline: !0
    },
    !Array.isArray(r) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", { src: r.src, type: r.mimeType }),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("track", { kind: "captions" })
  )));
  return i === "videoArticle" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__.B,
    {
      topPadding: _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.SMALL,
      bottomPadding: _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.LARGE,
      "data-testid": "article-video"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Content, { "data-testid": "article-video-content" }, p, s && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsCaption, d.videoCaption) }, s))
  )) : p;
}

//# sourceMappingURL=Video-83c15c06.mjs.map


/***/ })

}]);